import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "../entities/formTemplateDataType";
import { PDFCheckBox, PDFDocument } from "pdf-lib";
import * as html2pdf from 'html2pdf.js';
// import * as pdfjsLib from 'pdfjs-dist';
import DataUtils from "./DataUtils";


export class PdfUtils{
    static async bindPdf(programContainer: ProgramContainer) {
        const data = programContainer.pdfTemplate.split(",")[1];
        const byteCharacters = atob(data);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

    //    const pdfDoc = await PDFDocument.load(byteArray, { ignoreEncryption: true });
        // const form = pdfDoc.getForm();

        // let caseObject = DataUtils.collectFormValue(programContainer, 'N');
        // console.log(caseObject);
        // let field
        // Object.keys(caseObject).forEach(key => {
        //     try {
        //         //since there is no way to get the type, we test one by one    
        //         const pdfKey = key.split("__").join(" ");

        //         if (caseObject[key] == 'Y' || caseObject[key] == 'N') {
        //             field = form.getCheckBox(pdfKey);
        //             if (caseObject[key] == "Y")
        //                 (field as PDFCheckBox).check();
        //         } else {
        //             field = form.getTextField(pdfKey);
        //             if (field != null && caseObject[key] != null) {
        //                 field.setText(caseObject[key]);
        //             }
        //         }
        //     } catch (ex) {
        //         console.log(ex);
        //     }
        // })
        try{
           //  const pdfBytes = await pdfDoc.save(); 
             PdfUtils.downloadFile(byteArray, 'application/pdf');
        } catch{

        }
       
       
    }

    static async generateProgramContainer(programContainer: ProgramContainer) {
        // const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
        // pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        // const data = programContainer.pdfTemplate.split(",")[1];
        // const byteCharacters = atob(data);

        // const byteNumbers = new Array(byteCharacters.length);
        // for (let i = 0; i < byteCharacters.length; i++) {
        //     byteNumbers[i] = byteCharacters.charCodeAt(i);
        // }
        // const byteArray = new Uint8Array(byteNumbers);


        // const pdfDoc = await pdfjsLib.getDocument(byteArray).promise;
        // const pageNum = await pdfDoc.numPages

        // let sectionList = [];

        // for (var i = 1; i < pageNum + 1; i++) {
        //     const page = await pdfDoc.getPage(i);
        //     let section: FormSections = new FormSections();
        //     section.parent=programContainer
        //     section.Id = i.toString();
        //     section.Sequence = i;
        //     sectionList.push(section);
        //     let subSection = new FormSubSections();
        //     subSection.Id = "1";
        //     subSection.Sequence = 1
        //     subSection.SectionId = section.Id;
        //     subSection.parent=section;
        //     let ListOfFormSubSections=[];
        //     ListOfFormSubSections.push(subSection);
        //     section.ListOfFormSubSections=ListOfFormSubSections;

        //     const formFields = await page.getAnnotations();
        //     console.log(formFields);
        //     formFields.forEach((formfield, index) => {
        //         let element = new FormSectionElements();
        //         if (formfield.fieldName) {
        //             element.LoadBindName = formfield.fieldName.split(" ").join("_");
        //             element.ENUTitle = formfield.alternativeText;
        //             element.Sequence = index;
        //             element.Id = `ele${i}${index}`;
        //             element.Datatype="Text";
        //             element.Editable='Y';
        //             element.parent=subSection;
        //             subSection.ListOfFormSectionElements.push(element);
        //         }

        //     })
        // }

        // programContainer.ListOfFormSections=sectionList;
        // return programContainer;
    }

    static downloadFile(pdfData, mimeType) {
        if (pdfData) {
            const blob = new Blob([pdfData], { type: mimeType});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'downloaded.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } else {
            alert('No PDF loaded. Please select a PDF file first.');
        }
    }
    
}

export const htmlToPdf = async (element: HTMLElement) => {
    try {
        const opt = {
            margin:       [0.5, 0.25, 0.5, 0.25],
            filename:     'download.pdf',
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 2 },
            jsPDF:        { unit: 'in', format: 'A4', orientation: 'Portrait' },
            pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] },
        };
        const pdf = await html2pdf().set(opt).from(element).toPdf().get('pdf');
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setLineWidth(0.02);
            pdf.line(0.4, height - 0.5, width - 0.4, height - 0.5);
            pdf.text("© King's Printer for Ontario 2025", 0.5, height - 0.3);
            pdf.text(`Page ${i} of ${totalPages}`, width - 1.2, height - 0.3);
        }
        const pdfData = await pdf.output('arraybuffer');
        PdfUtils.downloadFile(pdfData, 'application/pdf');
    } catch (error) {
        console.error('Error generating PDF', error);
    }
    return null;
}